<template>
	<!--<el-checkbox
		ref="input"
		class="input-sigarus-checkbox"
		v-bind="{...$attrs, ...$props}"
		v-model="model">{{label}}</el-checkbox>-->
	
	<quill-editor
		ref="input"
		v-model="model"
		:options="editorOption"
	/>
</template>

<script>
	
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

	import { quillEditor } from 'vue-quill-editor'

	export default {
		name: 'InputSigarusEditor',
		components: {
			quillEditor
		},
		props: {
			value: {
				default: ''
			},
			label:  {
				default: ''
			}
		},
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['blockquote', 'code-block'],
							[{ 'header': 1 }, { 'header': 2 }],
							[{ 'list': 'ordered' }, { 'list': 'bullet' }],
							[{ 'script': 'sub' }, { 'script': 'super' }],
							[{ 'indent': '-1' }, { 'indent': '+1' }],
							[{ 'direction': 'rtl' }],
							[{ 'size': ['small', false, 'large', 'huge'] }],
							[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
							[{ 'color': [] }, { 'background': [] }],
							[{ 'align': [] }],
							['clean'],
							['link', 'video']
						],
						syntax: {
							highlight: text => hljs.highlightAuto(text).value
						}
					}
				}
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.select(), 200) }
		}
	}
</script>